import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const PaymentFailed = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const errorMessage = searchParams.get("error") || 
                      searchParams.get("message") || 
                      t("payment_failed_please_try_again");
  const planId = searchParams.get("plan_id");
  const amount = searchParams.get("amount");
  const duration = searchParams.get("duration");

  
  const handleRetry = () => {
    navigate(`/signup?plan_id=${planId}&amount=${amount}&duration=${duration}`);
  };

  useEffect(() => {
    toast.error(errorMessage);
  }, [errorMessage, planId]);

  return (
    <FailedWrapper>
      <div className="failed-container">
        <div className="failed-icon">✕</div>
        <h1>{t("payment_failed")}</h1>
        <p className="error-message">{errorMessage}</p>

        <div className="actions">
          <button className="btn btn-primary" onClick={handleRetry}>
            {t("try_again")}
          </button>
        </div>

        <p className="help-text">
          {t("if_problem_persists")},
          <a href="mailto:support@officely.com"> {t("contact_us")}</a>
        </p>
      </div>
    </FailedWrapper>
  );
};

export default PaymentFailed;

const FailedWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);

  .failed-container {
    text-align: center;
    background: white;
    padding: 60px 40px;
    border-radius: 10px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
    max-width: 500px;
    width: 90%;
  }

  .failed-icon {
    font-size: 80px;
    color: #f44336;
    margin-bottom: 20px;
    animation: shake 0.5s ease-in-out;
  }

  h1 {
    color: #333;
    margin-bottom: 15px;
    font-size: 28px;
  }

  .error-message {
    color: #d32f2f;
    font-size: 16px;
    line-height: 1.6;
    margin: 20px 0;
    padding: 15px;
    background-color: #ffebee;
    border-left: 4px solid #f44336;
  }

  .actions {
    display: flex;
    gap: 10px;
    margin: 30px 0;
    flex-direction: column;

    @media (min-width: 600px) {
      flex-direction: row;
      justify-content: center;
    }
  }

  .btn {
    padding: 12px 30px;
    font-size: 16px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: all 0.3s ease;
    flex: 1;

    @media (min-width: 600px) {
      flex: 0;
      min-width: 150px;
    }

    &.btn-primary {
      background-color: #667eea;
      color: white;

      &:hover {
        background-color: #5568d3;
        transform: translateY(-2px);
      }
    }

    &.btn-secondary {
      background-color: #f5f5f5;
      color: #333;
      border: 1px solid #ddd;

      &:hover {
        background-color: #e8e8e8;
      }
    }
  }

  .help-text {
    color: #666;
    font-size: 14px;
    margin-top: 20px;

    a {
      color: #667eea;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  @keyframes shake {
    0%,
    100% {
      transform: translateX(0);
    }
    10%,
    90% {
      transform: translateX(-10px);
    }
    20%,
    80% {
      transform: translateX(10px);
    }
    30%,
    70% {
      transform: translateX(-10px);
    }
    40%,
    60% {
      transform: translateX(10px);
    }
    50% {
      transform: translateX(-5px);
    }
  }

  @media (max-width: 600px) {
    .failed-container {
      padding: 40px 20px;
    }

    h1 {
      font-size: 24px;
    }

    .error-message {
      font-size: 14px;
    }

    .failed-icon {
      font-size: 60px;
    }
  }
`;